'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactForms = require('@selfdetermine/react-forms');
var reactElements = require('@selfdetermine/react-elements');
var graphql = require('@selfdetermine/graphql');
var reactHooks = require('@selfdetermine/react-hooks');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var format = function format(type, value) {
  var formattedValue = value;

  if (["counsel", "family", "person", "bank"].includes(type)) {
    formattedValue = Array.isArray(value) ? value.map(function (_ref) {
      var id = _ref.id;
      return id;
    }).filter(Boolean) : value === null || value === void 0 ? void 0 : value.id;
  } // Association fields that we need to send an object with the id and type


  if (["partyable"].includes(type)) {
    if (Array.isArray(value)) {
      formattedValue = value.map(function (_ref2) {
        var id = _ref2.id,
            __typename = _ref2.__typename;

        if (id && type) {
          return {
            id: id,
            type: __typename
          };
        }

        return false;
      }).filter(Boolean);
    } else {
      formattedValue = (value === null || value === void 0 ? void 0 : value.__typename) && (value === null || value === void 0 ? void 0 : value.id) ? {
        id: value.id,
        type: value.__typename
      } : null;
    }
  }

  return formattedValue;
};
var criminalCaseTypes = {
  misdemeanor: "Misdemeanor",
  infraction: "Infraction",
  juvenile: "Juvenile",
  fish_and_game: "Fish and Game",
  domestic_violence: "Domestic Violence",
  appeal: "Appeal"
};
var civilCaseTypes = {
  estate_planning: "Estate Planning",
  probate: "Probate",
  domestic_relations: "Domestic Relations",
  adult_protection: "Adult Protection",
  public_benefits: "Public Benefits",
  housing: "Housing",
  appeal: "Appeal",
  guardianship: "Guardianship",
  youth_in_need_of_care: "Youth in Need of Care",
  foreign_judgment: "Foreign Judgment"
};
var stateCodes = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      mutation($vehicle: NewVehicleInput!) {\n        addVehicle(vehicle: $vehicle) {\n          id\n          make\n          plateNumber\n          state\n        }\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        statutes {\n          id\n          revision\n          name\n          code\n          kind\n        }\n      }\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      mutation($matter: ID!, $charge: UpdateChargeInput!) {\n        updateCharge(case: $matter, charge: $charge) {\n          id\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      mutation($matter: ID!, $charge: AddChargeInput!) {\n        addChargeToMatter(case: $matter, charge: $charge) {\n          id\n        }\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      mutation($case: ID!, $note: ID!) {\n        deleteNoteFromCase(case: $case, note: $note) {\n          id\n          notes {\n            body\n          }\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      mutation($matter: ID!, $body: String!) {\n        addNoteToMatter(case: $matter, body: $body) {\n          id\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      mutation($matter: UpdateCriminalMatterInput!) {\n        updateCriminalMatter(matter: $matter) {\n          id\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      mutation($matter: UpdateMatterInput!) {\n        updateMatter(matter: $matter) {\n          id\n        }\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      query Matter($id: ID!) {\n        viewer {\n          matter(id: $id) {\n            id\n            status\n            caseNumber\n            kind\n            citationNumber\n            citedSpeed\n            postedSpeed\n            lbsOverWeight\n            violatedAt\n            representation\n            permittedStates\n            createdAt\n            modifiedAt\n            closedAt\n            filedAt\n            openedOn\n            warrants {\n              id\n              description\n              createdAt\n              modifiedAt\n            }\n            charges {\n              statute {\n                id\n                code\n                name\n                revision\n              }\n              plea\n              pledOn\n              disposition\n            }\n            referringEntity {\n              name\n            }\n            primaryParties {\n              id\n              firstName\n              lastName\n              memberStatus\n              sex\n              membershipNumber\n              bornAt\n              deceasedAt\n            }\n            adverseParties {\n              ... on Person {\n                id\n                firstName\n                lastName\n                memberStatus\n                sex\n                membershipNumber\n                bornAt\n                deceasedAt\n              }\n            }\n            regardingParties {\n              ... on Person {\n                id\n                firstName\n                lastName\n                memberStatus\n                sex\n                membershipNumber\n                bornAt\n                deceasedAt\n              }\n            }\n            primaryCounsels {\n              id\n              name\n            }\n            opposingCounsels {\n              id\n              name\n            }\n            judge {\n              id\n              email\n            }\n            referrals {\n              description\n              referred {\n                name\n                inboundReferrals {\n                  id\n                }\n              }\n              id\n            }\n            hearings {\n              kind\n              startedAt\n            }\n            officers {\n              id\n              badgeNumber\n              name\n              agency\n              badgeNumberSuffix\n            }\n            vehicles {\n              id\n              make\n              plateNumber\n              state\n            }\n            notes {\n              id\n              createdAt\n              createdBy {\n                email\n              }\n              body\n              owner {\n                ... on Case {\n                  id\n                }\n              }\n            }\n            history {\n              id\n              event\n              changes\n              createdAt\n              user {\n                id\n                email\n              }\n            }\n          }\n        }\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var useMatter = function useMatter() {
  var _data$viewer;

  var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useQuery = reactHooks.useQuery(graphql.gql(_templateObject()), _objectSpread2({
    variables: variables
  }, options)),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  var matter = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.matter;
  return [matter, meta];
};
var useUpdate = function useUpdate() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useMutation = reactHooks.useMutation(graphql.gql(_templateObject2())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var update = function update() {
    var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mutate({
      variables: {
        matter: _objectSpread2({
          id: matter.id
        }, changes)
      }
    });
  };

  return [update, meta];
};
var useUpdateCriminal = function useUpdateCriminal() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useMutation3 = reactHooks.useMutation(graphql.gql(_templateObject3())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update() {
    var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mutate({
      variables: {
        matter: _objectSpread2({
          id: matter.id
        }, changes)
      }
    });
  };

  return [update, meta];
};
var useAddNoteToMatter = function useAddNoteToMatter() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useMutation5 = reactHooks.useMutation(graphql.gql(_templateObject4())),
      _useMutation6 = _slicedToArray(_useMutation5, 2),
      mutate = _useMutation6[0],
      meta = _useMutation6[1];

  var update = function update(_ref) {
    var body = _ref.body;
    mutate({
      variables: {
        matter: matter.id,
        body: body
      }
    });
  };

  return [update, meta];
};
var useDeleteNoteFromCase = function useDeleteNoteFromCase() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var note = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useMutation7 = reactHooks.useMutation(graphql.gql(_templateObject5())),
      _useMutation8 = _slicedToArray(_useMutation7, 2),
      mutate = _useMutation8[0],
      meta = _useMutation8[1];

  var remove = function remove() {
    mutate({
      variables: {
        "case": matter.id,
        note: note.id
      }
    });
  };

  return [remove, meta];
};
var useNewCharge = function useNewCharge() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useMutation9 = reactHooks.useMutation(graphql.gql(_templateObject6())),
      _useMutation10 = _slicedToArray(_useMutation9, 2),
      mutate = _useMutation10[0],
      meta = _useMutation10[1];

  var create = function create(charge) {
    mutate({
      variables: {
        matter: matter.id,
        charge: charge
      }
    });
  };

  return [create, meta];
};
var useUpdateCharge = function useUpdateCharge() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var charge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useMutation11 = reactHooks.useMutation(graphql.gql(_templateObject7())),
      _useMutation12 = _slicedToArray(_useMutation11, 2),
      mutate = _useMutation12[0],
      meta = _useMutation12[1];

  var update = function update(changes) {
    mutate({
      variables: {
        matter: matter.id,
        charge: _objectSpread2({
          id: charge.id
        }, changes)
      }
    });
  };

  return [update, meta];
};
var useStatutes = function useStatutes() {
  var _query$data, _query$data$viewer;

  var query = reactHooks.useQuery(graphql.gql(_templateObject8()));
  var statutes = query === null || query === void 0 ? void 0 : (_query$data = query.data) === null || _query$data === void 0 ? void 0 : (_query$data$viewer = _query$data.viewer) === null || _query$data$viewer === void 0 ? void 0 : _query$data$viewer.statutes;
  return [statutes, query];
};
var useAddVehicle = function useAddVehicle() {
  var matter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useMutation13 = reactHooks.useMutation(graphql.gql(_templateObject9())),
      _useMutation14 = _slicedToArray(_useMutation13, 2),
      mutate = _useMutation14[0],
      meta = _useMutation14[1];

  var create = function create(vehicle) {
    mutate({
      variables: _objectSpread2({
        matter: matter.id
      }, vehicle)
    });
  };

  return [create, meta];
};

var AdversePartyForm = function AdversePartyForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdate = useUpdate(matter),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      meta = _useUpdate2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update({
                adverseParties: format("partyable", form.adverseParties),
                opposingCounsels: format("counsel", form.opposingCounsels)
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter,
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    label: "Person",
    name: "adverseParties"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "counsel",
    label: "Counsel",
    name: "opposingCounsels"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
AdversePartyForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    mutation($matter: NewMatterInput!) {\n      matter: addMatter(matter: $matter) {\n        id\n      }\n    }\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    mutation($matter: NewCriminalMatterInput!) {\n      matter: addCriminalMatter(matter: $matter) {\n        id\n      }\n    }\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var NewCriminalCaseForm = function NewCriminalCaseForm(_ref) {
  var defaultDefendant = _ref.defendant,
      onCancel = _ref.onCancel,
      onDone = _ref.onDone,
      onError = _ref.onError;

  var _useMutation = reactHooks.useMutation(graphql.gql(_templateObject$1())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      create = _useMutation2[0],
      meta = _useMutation2[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create({
                variables: {
                  matter: _objectSpread2(_objectSpread2({}, form), {}, {
                    adverseParties: format("partyable", form.adverseParties || defaultDefendant)
                  })
                }
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    onSubmit: handleSubmit,
    loading: meta.loading,
    error: meta.error
  }, !(defaultDefendant === null || defaultDefendant === void 0 ? void 0 : defaultDefendant.id) && !(defaultDefendant === null || defaultDefendant === void 0 ? void 0 : defaultDefendant.__typename) ? /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Title, {
    size: "2"
  }, "Defendant"), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    required: true,
    name: "adverseParties",
    label: "Defendant"
  })) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Title, {
    size: "2"
  }, "Details"), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "kind",
    label: "Type of Citation",
    required: true,
    options: Object.entries(criminalCaseTypes).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          value = _ref4[0],
          label = _ref4[1];

      return {
        label: label,
        value: value
      };
    })
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "date",
    label: "Date of Violation",
    name: "violatedAt"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "text",
    label: "Citation Number",
    name: "citationNumber"
  })), /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level, {
    mobile: true
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Create"))))));
};
NewCriminalCaseForm.propTypes = {
  defendant: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].number
  }),
  onCancel: PropTypes__default['default'].func,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func
};
var NewCivilCaseForm = function NewCivilCaseForm(_ref5) {
  var onCancel = _ref5.onCancel,
      onDone = _ref5.onDone,
      onError = _ref5.onError;

  var _useMutation3 = reactHooks.useMutation(graphql.gql(_templateObject2$1())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      create = _useMutation4[0],
      meta = _useMutation4[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return create({
                variables: {
                  matter: _objectSpread2(_objectSpread2({}, form), {}, {
                    adverseParties: format("partyable", form.adverseParties),
                    primaryParties: format("partyable", form.primaryParties),
                    regardingParties: format("partyable", form.regardingParties),
                    opposingCounsels: format("counsel", form.opposingCounsels),
                    primaryCounsels: format("counsel", form.primaryCounsels)
                  })
                }
              });

            case 3:
              response = _context2.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              if (typeof onError === "function") {
                onError(_context2.t0, form);
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function handleSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    onSubmit: handleSubmit,
    loading: meta.loading,
    error: meta.error,
    defaultValues: {
      adverseParties: [],
      primaryCounsels: [],
      regardingParties: [],
      opposingCounsels: [],
      primaryParties: []
    }
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Title, {
    size: "2"
  }, "Parties and Representation"), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "kind",
    label: "Type of Citation",
    required: true,
    options: Object.entries(civilCaseTypes).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          value = _ref8[0],
          label = _ref8[1];

      return {
        label: label,
        value: value
      };
    })
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    multiple: true,
    name: "primaryParties",
    label: "Petitioner"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "counsel",
    multiple: true,
    name: "primaryCounsels",
    label: "Petitioner Counsel"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    multiple: true,
    name: "adverseParties",
    label: "Adverse Party"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "counsel",
    multiple: true,
    name: "opposingCounsels",
    label: "Adverse Counsel"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    multiple: true,
    name: "regardingParties",
    label: "Interested Party"
  })), /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level, {
    mobile: true
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Create"))))));
};
NewCivilCaseForm.propTypes = {
  onCancel: PropTypes__default['default'].func,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func
};

var ChargeForm = function ChargeForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdateCriminal = useUpdateCriminal(matter),
      _useUpdateCriminal2 = _slicedToArray(_useUpdateCriminal, 2),
      update = _useUpdateCriminal2[0],
      meta = _useUpdateCriminal2[1];

  var _useStatutes = useStatutes(),
      _useStatutes2 = _slicedToArray(_useStatutes, 2),
      statutes = _useStatutes2[0],
      statuteMeta = _useStatutes2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update({
                charges: matter.charges.map(function (_ref3) {
                  var _currentCharge$statut;

                  var __typename = _ref3.__typename,
                      currentCharge = _objectWithoutProperties(_ref3, ["__typename"]);

                  return _objectSpread2(_objectSpread2({}, currentCharge), {}, {
                    statute: (_currentCharge$statut = currentCharge.statute) === null || _currentCharge$statut === void 0 ? void 0 : _currentCharge$statut.id
                  });
                }).concat([form])
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    label: "Statute",
    name: "statute",
    required: true,
    options: (statutes || []).map(function (statute) {
      return {
        value: statute.id,
        label: "".concat(statute.code, " - ").concat(statute.name, " (").concat(statute.revision, ")")
      };
    }),
    loading: statuteMeta.loading
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "string",
    label: "Plea",
    name: "plea"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "date",
    label: "Pled On",
    name: "pledOn"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "string",
    label: "Disposition",
    name: "disposition"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Create")))));
};
ChargeForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    charges: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      statute: PropTypes__default['default'].shape({
        id: PropTypes__default['default'].string,
        code: PropTypes__default['default'].string,
        name: PropTypes__default['default'].string,
        plea: PropTypes__default['default'].string,
        pledOn: PropTypes__default['default'].string,
        disposition: PropTypes__default['default'].string
      })
    })),
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var DetailsForm = function DetailsForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdateCriminal = useUpdateCriminal(matter),
      _useUpdateCriminal2 = _slicedToArray(_useUpdateCriminal, 2),
      update = _useUpdateCriminal2[0],
      meta = _useUpdateCriminal2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update(_objectSpread2(_objectSpread2(_objectSpread2({}, (form === null || form === void 0 ? void 0 : form.citedSpeed) && {
                citedSpeed: Number(form.citedSpeed)
              }), (form === null || form === void 0 ? void 0 : form.postedSpeed) && {
                postedSpeed: Number(form.postedSpeed)
              }), (form === null || form === void 0 ? void 0 : form.lbsOverWeight) && {
                lbsOverWeight: Number(form.lbsOverWeight)
              }));

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter,
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "number",
    label: "Cited speed",
    name: "citedSpeed",
    min: "0"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "number",
    label: "Posted speed",
    name: "postedSpeed",
    step: "5",
    min: "0"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "number",
    label: "Pounds over weight",
    name: "lbsOverWeight",
    min: "0"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
DetailsForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var HearingsForm = function HearingsForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdate = useUpdate(matter),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      meta = _useUpdate2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var hearing, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              hearing = {
                hearings: form
              };
              _context.prev = 1;
              _context.next = 4;
              return update(hearing);

            case 4:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter,
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "startedAt",
    label: "Starting Date & Time",
    type: "datetime-local"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "kind",
    label: "Type of Hearing",
    options: [{
      label: "Arraignment",
      value: "arraignment"
    }, {
      label: "Admit/Deny",
      value: "admit_deny"
    }]
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
HearingsForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  query Matters($first: Int, $after: String, $sort: SortInput!) {\n    viewer {\n      matters(first: $first, after: $after, sort: $sort) {\n        totalCount\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n        edges {\n          node {\n            caseNumber\n            kind\n            closedAt\n            createdAt\n            description\n            id\n            kind\n            openedOn\n            outsideIdentifier\n            regardingParties {\n              ... on Person {\n                id\n                firstName\n                lastName\n                bornAt\n                profileImage {\n                  url\n                }\n              }\n            }\n            adverseParties {\n              ... on Person {\n                id\n                firstName\n                lastName\n                bornAt\n              }\n            }\n            primaryParties {\n              ... on Person {\n                id\n                firstName\n                lastName\n                bornAt\n                profileImage {\n                  url\n                }\n              }\n            }\n            representation\n            selfReferral\n            status\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var MATTERS_QUERY = graphql.gql(_templateObject$2());
var Search = function Search() {
  var _data$viewer, _data$viewer$matters, _data$viewer$matters$;

  var _useQuery = reactHooks.useQuery(MATTERS_QUERY, {
    variables: {
      first: 5,
      after: null,
      sort: {}
    }
  }),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading,
      fetchMore = _useQuery.fetchMore;

  var history = reactRouterDom.useHistory();
  var hasNextPage = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$matters = _data$viewer.matters) === null || _data$viewer$matters === void 0 ? void 0 : (_data$viewer$matters$ = _data$viewer$matters.pageInfo) === null || _data$viewer$matters$ === void 0 ? void 0 : _data$viewer$matters$.hasNextPage;
  if (error) return /*#__PURE__*/React__default['default'].createElement("div", null, "errors");
  if (loading || !data) return /*#__PURE__*/React__default['default'].createElement("div", null, "loading");

  function getMoreMatters() {
    var _data$viewer2, _data$viewer2$matters;

    var _data$viewer$matters$2 = data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : (_data$viewer2$matters = _data$viewer2.matters) === null || _data$viewer2$matters === void 0 ? void 0 : _data$viewer2$matters.pageInfo,
        endCursor = _data$viewer$matters$2.endCursor;

    fetchMore({
      variables: {
        after: endCursor
      },
      updateQuery: function updateQuery(prevResult, _ref) {
        var fetchMoreResult = _ref.fetchMoreResult;
        // eslint-disable-next-line no-param-reassign
        fetchMoreResult.viewer.matters.edges = [].concat(_toConsumableArray(prevResult.viewer.matters.edges), _toConsumableArray(fetchMoreResult.viewer.matters.edges));
        return fetchMoreResult;
      }
    });
  }

  return /*#__PURE__*/React__default['default'].createElement(reactElements.Columns, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, {
    size: "3"
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Content, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    disabled: true,
    onSubmit: function onSubmit() {}
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "search",
    name: "term",
    label: "Search Case"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "type",
    label: "Type of Matter",
    options: [{
      label: "All Matters",
      value: ""
    }]
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "sort",
    label: "Sort By",
    className: "is-fullwidth",
    options: [""]
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, {
    mobile: true
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Left, null), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Search")))))))), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, {
    style: {
      marginBottom: "2rem"
    }
  }, data.viewer.matters.edges.map(function (_ref2) {
    var node = _ref2.node;
    return /*#__PURE__*/React__default['default'].createElement(reactElements.Card, {
      style: {
        borderBottom: "1px solid #eee"
      },
      key: node.id
    }, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Content, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        display: "block",
        fontWeight: "bold",
        fontSize: "0.75rem",
        opacity: "0.5"
      }
    }, " ", "Case Number", " "), node.caseNumber, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        display: "block",
        fontWeight: "bold",
        fontSize: "0.75rem",
        opacity: "0.5",
        marginTop: "0.5rem"
      }
    }, "Adverse Party"), node.regardingParties.map(function (party) {
      return /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(party.firstName, " ").concat(party.lastName, " ").concat(party.bornAt));
    })), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        display: "block",
        fontWeight: "bold",
        fontSize: "0.75rem",
        opacity: "0.5"
      }
    }, "Category"), node.kind ? node.kind : node.category, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        display: "block",
        fontWeight: "bold",
        fontSize: "0.75rem",
        opacity: "0.5",
        marginTop: "0.5rem"
      }
    }, "Petitioner"), node.adverseParties.map(function (party) {
      return /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(party.firstName, " ").concat(party.lastName, " ").concat(party.bornAt));
    })), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        display: "block",
        fontWeight: "bold",
        fontSize: "0.75rem",
        opacity: "0.5"
      }
    }, "Defendant"), node.primaryParties.map(function (party) {
      return /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(party.firstName, " ").concat(party.lastName, " ").concat(party.bornAt));
    })), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
      style: {
        display: "block",
        marginLeft: "auto"
      },
      onClick: function onClick() {
        return history.push("/matters/".concat(node.id));
      }
    }, "View case"), /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        textAlign: "right",
        display: "block",
        marginTop: "3rem",
        fontSize: "0.75rem",
        opacity: "0.2"
      }
    }, "System ID: ", node.id)))));
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    style: {
      display: "block",
      margin: "1rem auto"
    },
    disabled: !hasNextPage,
    onClick: getMoreMatters
  }, hasNextPage ? "Load more cases" : "No more cases found")));
};

/**
 * Card component for displaying a given person.
 */

var PersonCard = function PersonCard(_ref) {
  var person = _ref.person,
      children = _ref.children,
      footer = _ref.footer;
  var history = reactRouterDom.useHistory();
  return /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Content, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns, {
    mobile: true
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "is-size-7 has-text-weight-bold has-text-grey"
  }, "Full Name"), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "has-text-weight-bold"
  }, [person.firstName, person.middleName, person.lastName].filter(Boolean).join(" ")), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "is-size-7 has-text-weight-bold has-text-grey mt-2"
  }, "Gender"), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "is-capitalized"
  }, person.sex)), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "is-size-7 has-text-weight-bold has-text-grey"
  }, "Membership Number"), person.membershipNumber, /*#__PURE__*/React__default['default'].createElement("span", {
    className: ""
  }, person.memberStatus), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "is-size-7 has-text-weight-bold has-text-grey mt-2"
  }, "Birth Date"), person.bornAt ? person.bornAt : "Unknown", "\u2014", person.deceasedAt ? person.deceasedAt : "Present"), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    style: {
      display: "block",
      marginLeft: "auto"
    },
    onClick: function onClick() {
      return history.push("/people/".concat(person.id));
    }
  }, "View person"), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "is-size-7 has-text-grey-light has-text-right mt-4 pr-2"
  }, "System ID: ", person.id))), children), footer);
};
PersonCard.propTypes = {
  /** Person instance to display */
  person: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].number,
    firstName: PropTypes__default['default'].string,
    middleName: PropTypes__default['default'].string,
    lastName: PropTypes__default['default'].string,
    bornAt: PropTypes__default['default'].string,
    deceasedAt: PropTypes__default['default'].string,
    sex: PropTypes__default['default'].string,
    membershipNumber: PropTypes__default['default'].string,
    memberStatus: PropTypes__default['default'].string
  }).isRequired,

  /** Extra card content */
  children: PropTypes__default['default'].node,

  /** Card footer. Generally should be a `Card.Footer` component */
  footer: PropTypes__default['default'].node
};

var PrimaryPartyForm = function PrimaryPartyForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdate = useUpdate(matter),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      meta = _useUpdate2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update({
                primaryParties: format("partyable", form.primaryParties),
                primaryCounsels: format("counsel", form.primaryCounsels)
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter,
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "partyable",
    label: "Person",
    name: "primaryParties"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "counsel",
    label: "Counsel",
    name: "primaryCounsels"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
PrimaryPartyForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var JudgeForm = function JudgeForm(_ref) {
  var _matter$judge;

  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdateCriminal = useUpdateCriminal(matter),
      _useUpdateCriminal2 = _slicedToArray(_useUpdateCriminal, 2),
      update = _useUpdateCriminal2[0],
      meta = _useUpdateCriminal2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update({
                judge: form.judge
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: {
      judge: matter === null || matter === void 0 ? void 0 : (_matter$judge = matter.judge) === null || _matter$judge === void 0 ? void 0 : _matter$judge.id
    },
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "judge",
    label: "Assigned Judge",
    name: "judge"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
JudgeForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    judge: PropTypes__default['default'].string
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var NoteForm = function NoteForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useAddNoteToMatter = useAddNoteToMatter(matter),
      _useAddNoteToMatter2 = _slicedToArray(_useAddNoteToMatter, 2),
      update = _useAddNoteToMatter2[0],
      meta = _useAddNoteToMatter2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form, submitEvent) {
      var response, _submitEvent$target;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update(form);

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);

                if (typeof (submitEvent === null || submitEvent === void 0 ? void 0 : (_submitEvent$target = submitEvent.target) === null || _submitEvent$target === void 0 ? void 0 : _submitEvent$target.reset) === "function") {
                  submitEvent.target.reset();
                }
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Textarea, {
    name: "body",
    label: "New Action"
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Save")))));
};
NoteForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    }))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var OfficerForm = function OfficerForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useUpdateCriminal = useUpdateCriminal(matter),
      _useUpdateCriminal2 = _slicedToArray(_useUpdateCriminal, 2),
      update = _useUpdateCriminal2[0],
      meta = _useUpdateCriminal2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return update({
                officers: form.officers.map(function (_ref3) {
                  var id = _ref3.id;
                  return id;
                })
              });

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter,
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    type: "officer",
    label: "Officers",
    name: "officers",
    multiple: true
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
OfficerForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    officers: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
  }),
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

var VehicleForm = function VehicleForm(_ref) {
  var matter = _ref.matter,
      onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel;

  var _useAddVehicle = useAddVehicle(matter),
      _useAddVehicle2 = _slicedToArray(_useAddVehicle, 2),
      update = _useAddVehicle2[0],
      meta = _useAddVehicle2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var make, plateNumber, state, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              make = form.make, plateNumber = form.plateNumber, state = form.state;
              _context.prev = 1;
              _context.next = 4;
              return update({
                vehicle: {
                  make: make,
                  plateNumber: plateNumber,
                  state: state,
                  matter: matter.id
                }
              });

            case 4:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              if (typeof onError === "function") {
                onError(_context.t0, form);
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    defaultValues: matter.vehicles[0],
    onSubmit: submit,
    loading: meta.loading,
    error: meta.error
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "make",
    label: "Make",
    type: "text"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "plateNumber",
    label: "License Plate #",
    type: "text"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Select, {
    name: "state",
    label: "State",
    options: stateCodes
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" ? /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "button",
    onClick: onCancel
  }, "Cancel")) : null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Update")))));
};
VehicleForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    adverseParties: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      firstName: PropTypes__default['default'].string,
      lastName: PropTypes__default['default'].string
    })),
    opposingCounsels: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      name: PropTypes__default['default'].string
    })),
    vehicles: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({}))
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func
};

exports.AdversePartyForm = AdversePartyForm;
exports.ChargeForm = ChargeForm;
exports.DetailsForm = DetailsForm;
exports.HearingsForm = HearingsForm;
exports.JudgeForm = JudgeForm;
exports.NewCivilCaseForm = NewCivilCaseForm;
exports.NewCriminalCaseForm = NewCriminalCaseForm;
exports.NoteForm = NoteForm;
exports.OfficerForm = OfficerForm;
exports.PersonCard = PersonCard;
exports.PrimaryPartyForm = PrimaryPartyForm;
exports.Search = Search;
exports.VehicleForm = VehicleForm;
exports.criminalCaseTypes = criminalCaseTypes;
exports.useAddNoteToMatter = useAddNoteToMatter;
exports.useAddVehicle = useAddVehicle;
exports.useDeleteNoteFromCase = useDeleteNoteFromCase;
exports.useMatter = useMatter;
exports.useNewCharge = useNewCharge;
exports.useStatutes = useStatutes;
exports.useUpdate = useUpdate;
exports.useUpdateCharge = useUpdateCharge;
exports.useUpdateCriminal = useUpdateCriminal;
